import { OUR_SERVICE_IMAGE } from "../../../utils/constants";
import { getCloudinaryImageUrl } from "../../../utils/getCloudinaryImageUrl";

export default function MixMastersServices() {
  const services = [
    {
      number: "01",
      title: "Ready-Made Concrete Magic",
      description:
        "Premium, high-quality concrete customized to meet the unique requirements of your project.",
    },
    {
      number: "02",
      title: "Technology-Driven Production",
      description:
        "AI and Internet of Things (IoT) integrated systems designed to monitor and optimize concrete quality while minimizing waste.",
    },
    {
      number: "03",
      title: "Custom Mix Designs",
      description:
        "Enchanting blends crafted for strength, resilience, and setting time, tailored to elevate diverse endeavors.",
    },
    {
      number: "04",
      title: "Sustainability Practices",
      description:
        "The reuse of greywater and the implementation of environmentally sustainable practices in batching plant operations.",
    },
  ];

  return (
    <div className="w-full bg-white px-4 md:px-8 lg:px-10 ">
      <style>{`
        .service-card {
          transition: all 0.25s ease;
        }
        .service-card:hover {
          background: #faf5ff !important;
          box-shadow: 0 4px 20px rgba(192,32,208,0.08) !important;
          transform: translateY(-2px);
        }
      `}</style>

      <div className="pb-6 md:pb-10">
        {/* Top label */}
        <div className="text-center mb-4" data-aos="fade-up">
          <span
            className="text-xs font-medium tracking-widest uppercase"
            style={{ color: "#c020d0", letterSpacing: "0.2em" }}
          >
            [ OUR SERVICES ]
          </span>
        </div>

        {/* Heading */}
        <h2
          data-aos="fade-up"
          data-aos-delay="100"
          className="text-center text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-heading  font-semibold mb-8 md:mb-12  lg:leading-loose"
        >
          Empowering Industry Growth Through
          <br className="hidden sm:block" />
          Impactful and Innovative Solutions
        </h2>

        {/* Main content row */}
        <div className="flex flex-col md:flex-row md:gap-6 lg:gap-8">
          {/* Left image */}
          <div
            data-aos="fade-right"
            className="relative rounded-2xl overflow-hidden w-full md:w-2/5 lg:w-1/3 mb-6 md:mb-0"
            style={{
              background:
                "linear-gradient(160deg, #3a0a4a 0%, #6b0080 40%, #c020d0 100%)",
            }}
          >
            <img
              src={getCloudinaryImageUrl(OUR_SERVICE_IMAGE, { width: 500 })}
              alt="Service illustration"
              className="w-full h-full object-cover"
              style={{ minHeight: "240px" }}
            />
          </div>

          {/* Cards */}
          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-4 lg:gap-5">
            {services.map((s, i) => (
              <div
                key={s.number}
                data-aos="fade-up"
                data-aos-delay={i * 120}
                className="service-card bg-surfaceColor border border-primaryAccent/30 hover:bg-primaryAccent/40 hover:hover:border-primaryAccent rounded-2xl p-4 md:p-5 lg:p-6"
              >
                <p
                  className="font-semibold mb-2 text-sm"
                  style={{ color: "#c020d0" }}
                >
                  {s.number}
                </p>
                <h3 className="font-bold text-gray-900 mb-2 text-base md:text-lg leading-tight">
                  {s.title}
                </h3>
                <p className="text-gray-500 text-xs sm:text-sm leading-relaxed">
                  {s.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
